export default {"src":"/_next/static/media/client-08.d564fa68.svg","height":26,"width":98,"blurWidth":0,"blurHeight":0};